import Header from "../Header/Header"
import "./contact.css"

const Contact = () =>{
    return (
        <>
            <Header />
            <div className="full-screen-container">
                {/* <div className="camera-bg">
                    <div className="camera camera-1">📷</div>
                    <div className="camera camera-2">📸</div>
                    <div className="camera camera-3">📹</div>
                    <div className="camera camera-4">📷</div>
                    <div className="camera camera-5">📸</div>
                    <div className="camera camera-6">📹</div>
                    <div className="camera camera-7">📷</div>
                    <div className="camera camera-8">📸</div>
                    <div className="camera camera-9">📹</div>
                    <div className="camera camera-10">📷</div>
                    <div className="camera camera-12">📹</div>
                    <div className="camera camera-13">📷</div>
                    <div className="camera camera-14">📸</div>
                    <div className="camera camera-15">📹</div>
                    <div className="camera camera-16">📷</div>
                    <div className="camera camera-17">📸</div>
                    <div className="camera camera-18">📹</div>
                    <div className="camera camera-19">📷</div>
                    <div className="camera camera-20">📸</div>
                </div> */}
                <div className="contact-container">
                    <div className="contact-content">
                        <h1>Contact</h1>
                        <div className="contact-info">
                            <div className="contact-item">
                                <div className="contact-label">Email</div>
                                <a href="mailto:jackyammouni@gmail.com" className="contact-value">
                                    jackyammouni@gmail.com
                                </a>
                            </div>
                            <div className="contact-item">
                                <div className="contact-label">Phone</div>
                                <a href="tel:+96176318402" className="contact-value">
                                    +961 76318402
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
} 

export default Contact